// extracted by mini-css-extract-plugin
module.exports = {"categoryList":"filter_categoryList__2zgRu","highlighted":"filter_highlighted__1OXEs"};